import React from 'react';

import './LoadingModal.css';

const LoadingModal = ({ children }) => {
  return (
    <div className='loading-modal-backdrop'>
      <div className='loading-modal-container'>{children}</div>
    </div>
  );
};

export default LoadingModal;
